import React, { useEffect, useState } from "react";
import {
  Container,
  Breadcrumb,
  Button,
  Col,
  Row,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../data/AuthHook";
import { useBreadcrumb } from "../data/BreadcrumbHook";
import logo from "../logo.svg";
import "./Nav.css";

function Nav() {
  const navigate = useNavigate();
  const breadCrumbRepository = useBreadcrumb();
  const auth = useAuth();

  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  useEffect(() => {
    const breadcrumb = breadCrumbRepository.getBreadcrumb();
    setBreadcrumbItems(breadcrumb);
  }, [breadCrumbRepository]);

  const breadcrumbNavigate = ({ route, name }) => {
    navigate(route);
    const routeIndex = breadcrumbItems.findIndex((rt) => rt.name === name);
    setBreadcrumbItems(breadcrumbItems.slice(0, routeIndex + 1));
  };

  const clearBreadcrumb = () => {
    setBreadcrumbItems([]);
  };

  const clearAndNavigate = (route) => {
    navigate(route);
    clearBreadcrumb();
  };

  return (
    <Container className="coreContent nav-content">
      <Row>
        <Col xs={2}>
          <input
            type="image"
            src={logo}
            alt="Switch2 Logo"
            className="nav-logo"
            onClick={() => clearAndNavigate("/")}
          />
        </Col>
        <Col>
          <Breadcrumb className="nav-breadcrumb">
            {breadcrumbItems.map((breadcrumbItem, index) => {
              if (
                index === breadcrumbItems.length - 1 &&
                breadcrumbItem.route
              ) {
                return (
                  <Breadcrumb.Item
                    active
                    key={breadcrumbItem.name}
                    onClick={() => {
                      breadcrumbNavigate(breadcrumbItem);
                    }}
                  >
                    {breadcrumbItem.name}
                  </Breadcrumb.Item>
                );
              }
              if (
                index === breadcrumbItems.length - 1 &&
                !breadcrumbItem.route
              ) {
                return (
                  <Breadcrumb.Item
                    active
                    key={breadcrumbItem.name}
                    onClick={() => {}}
                  >
                    {breadcrumbItem.name}
                  </Breadcrumb.Item>
                );
              }
              return (
                <Breadcrumb.Item
                  active={breadcrumbItem.active}
                  key={breadcrumbItem.name}
                  onClick={() => {
                    breadcrumbNavigate(breadcrumbItem);
                  }}
                >
                  {breadcrumbItem.name}
                </Breadcrumb.Item>
              );
            })}
          </Breadcrumb>
        </Col>
        <Col>
          <div className="login-status">
            <span className="login-status-message" />
            <Button variant="secondary" onClick={() => clearAndNavigate("/")}>
              Search
            </Button>
            <span className="login-status-message" />
            <Button variant="danger" onClick={auth.logout}>
              Logout
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Nav;
